import { render, staticRenderFns } from "./IndicationList.vue?vue&type=template&id=010fec6a&scoped=true"
import script from "./IndicationList.vue?vue&type=script&lang=js"
export * from "./IndicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fec6a",
  null
  
)

export default component.exports